import { CASHIER_STEP_STATUSES } from "../CashierSteps/cashierStepsConstants";

export const DEPOSIT_QR_CODE_STEPS = [
    { status: CASHIER_STEP_STATUSES.WAITING, title: 'deposit.copy_the_provider_key' },
    { status: CASHIER_STEP_STATUSES.WAITING, title: 'deposit.paste_key_into_app' },
    { status: CASHIER_STEP_STATUSES.WAITING, title: 'deposit.confirm_payment' },
];
